module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_MURS_P21_UNI_CRISTAL_CHEVRON.75fd2fc5.png";